import classNames from 'classnames/bind';
import { useContext } from 'react';
import Cookies from 'universal-cookie';

import { SearchConditionIcon } from 'asset/svg';
import config from 'config/index';
import { InternationalContext, sortMethods } from 'contexts/international';
import { Modal, ModalFuncContext, ModalPosition } from 'contexts/modalFunc';
import {
  SubscriptionRoute,
  defaultPriceChangesActive,
  getSearchKey,
  usePriceChangesSubscription,
} from 'hooks/usePriceChangesSubscriptions';
import { TripType } from 'types/apollo';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const cookies = new Cookies();

interface Props {
  isLoading: boolean;
  searchParams: SubscriptionRoute;
}

export default function PriceAlert({ isLoading, searchParams }: Props) {
  const { orgFlights } = useContext(InternationalContext);
  const setModal = useContext(ModalFuncContext);
  const { loading, subscription } = usePriceChangesSubscription(
    getSearchKey(searchParams),
  );

  if (isLoading || !orgFlights || loading) {
    return <button type="button" className={cx('noti')} aria-busy />;
  }

  const {
    results: { fares },
  } = orgFlights;

  const updatedMinPrice = Math.min(
    ...Object.values(fares).flatMap(({ fare }) =>
      sortMethods.getLowestPrice(fare, 'A01'),
    ),
  );

  return (
    <button
      type="button"
      className={cx('noti')}
      aria-busy={loading}
      aria-checked={!!subscription}
      data-event-nlog="click"
      data-event-area-code={`${searchParams.tripType === TripType.Ow ? 'lon' : 'lrd'}.${!!subscription ? 'prion' : 'prigo'}`}
      onClick={() => {
        if (cookies.get('NID_SES')) {
          return setModal({
            position: ModalPosition.LIST,
            type: Modal.NOTIFICATION,
            payload: {
              isNew: !subscription,
              subscription: subscription || {
                ...searchParams,
                changes: defaultPriceChangesActive,
                originalMinPrice: updatedMinPrice,
              },
              updatedMinPrice,
            },
          });
        }
        if (window.confirm('로그인이 필요한 서비스입니다.')) {
          window.location.href = `${config.nAuthWithUrlParam}${encodeURIComponent(window.location.href)}`;
        }
      }}
    >
      <SearchConditionIcon className={cx('icon')} />
      {subscription ? '알림받는중' : '알림받기'}
      {!subscription && (
        <div className={cx('focusBubble')} role="tooltip">
          <b>가격 변동 알림</b> 받기
        </div>
      )}
    </button>
  );
}
